const imageManagerInformacoesProdutos = {
  imgProdutos: {
    imgResidencial:
      "https://banco-de-imagens-webapp-primesecure.s3.sa-east-1.amazonaws.com/seguro-residencial.webp",
    imgPet:
      "https://banco-de-imagens-webapp-primesecure.s3.sa-east-1.amazonaws.com/seguro-pet.webp",
    imgOdonto:
      "https://banco-de-imagens-webapp-primesecure.s3.sa-east-1.amazonaws.com/seguro-odonto.webp",
    imgVida:
      "https://banco-de-imagens-webapp-primesecure.s3.sa-east-1.amazonaws.com/seguro-de-vida.webp",
    imgViagem:
      "https://banco-de-imagens-webapp-primesecure.s3.sa-east-1.amazonaws.com/seguro-viagemlp.webp",
    imgCelular:
      "https://banco-de-imagens-webapp-primesecure.s3.sa-east-1.amazonaws.com/seguro-celular.webp",
  },
  imgSliderHomeProdutos: {
    imgSliderHomeResidencial:
      "https://storage.googleapis.com/primesecure/imgSliderHomeResidencial.webp",
    imgSliderHomePet:
      "https://storage.googleapis.com/primesecure/imgSliderHomePet.webp",
    imgSliderHomeOdonto:
      "https://storage.googleapis.com/primesecure/imgSliderHomeOdonto.webp",
    imgSliderHomeViagem:
      "https://storage.googleapis.com/primesecure/imgSliderHomeViagem.webp",
    imgSliderHomeVida:
      "https://storage.googleapis.com/primesecure/imgSliderHomeVida.webp",
    imgSliderHomeCelular:
      "https://storage.googleapis.com/primesecure/imgSliderHomeCelular.webp",
  },
  imgSliderHomeTrofeus: {
    imgSliderHomeBradesco1:
      "https://storage.googleapis.com/primesecure/trofeu-bradesco-1.webp",
    imgSliderHomeBradesco2:
      "https://storage.googleapis.com/primesecure/trofeu-bradesco-2.webp",
    imgSliderHomeBradesco3:
      "https://storage.googleapis.com/primesecure/trofeu-bradesco-3.webp",
    imgSliderHomeBradesco4:
      "https://storage.googleapis.com/primesecure/trofeu-bradesco-4.webp",
    imgSliderHomeBradesco5:
      "https://storage.googleapis.com/primesecure/trofeu-bradesco-5.webp",
    imgSliderHomeSulamerica:
      "https://storage.googleapis.com/primesecure/trofeu-sulamerica-1.webp",
    imgSliderHomePortoseguro:
      "https://storage.googleapis.com/primesecure/trofeu-portoseguro.webp",
    imgSliderHomePortoElite:
      "https://storage.googleapis.com/primesecure/certificado-elite-portoseguro.webp",
    imgSliderHomeDestaqueSulamerica1Semestre:
      "https://storage.googleapis.com/primesecure/destaque-sulamerica-1semestre.webp",
    imgSliderHomeDestaqueSulamerica3Trimestre:
      "https://storage.googleapis.com/primesecure/destaque-sulamerica-3trimestre.webp",
    imgSliderHomePortoAcelera:
      "https://storage.googleapis.com/primesecure/portoseguro-acelera.webp",
    imgSliderHomeSulamericaSuperCampeoes:
      "https://storage.googleapis.com/primesecure/sulamerica-super-campeoes.webp",
  },
};

export default imageManagerInformacoesProdutos;
